<div class="signWrp">
    <div class="row m-0">
        <div class="col-6 signBg">

        </div>
        <div class="col">
            <div class="signSub">
                <div>
                    <div *ngIf="isSignUpPage">
                        <h1>Almost there</h1>
                        <p>Let us know more about you!</p>
                    </div>
                    <div class="signForm">
                        <form [formGroup]="signupForm" (ngSubmit)="onSubmit(signupForm)">
                            <div *ngIf="isSignUpPage">
                                <div class="loginDetails">
                                    <h5>{{isMobile ? signUpMobile : signUpEmail}}</h5>
                                    <button (click)="onChange($event)">Change</button>
                                </div>
                                <input type="text" placeholder="Full Name*" formControlName="fullName" appInputText
                                    (keydown.enter)="onSubmit(signupForm, $event)">
                                <div *ngIf="errorMessage!='' && formControl['fullName'].invalid"
                                    class="alert alert-danger">
                                    <div *ngIf="formControl['fullName'].errors.required">
                                        Name is Required.
                                    </div>
                                    <div *ngIf="formControl['fullName'].errors.pattern">
                                        Name cannot have numbers or special characters
                                    </div>
                                </div>
                                <input type="text" placeholder="Email*" formControlName="email" appInputEmail
                                    (keydown.enter)="onSubmit(signupForm, $event)" />
                                <div *ngIf="errorMessage!='' && formControl['email'].invalid"
                                    class="alert alert-danger">
                                    <div *ngIf="formControl['email'].errors.required">
                                        Email is Required.
                                    </div>

                                    <div *ngIf="formControl['email'].errors.pattern">
                                        Email is Invalid.
                                    </div>
                                </div>
                                <button class="btn btn-danger" type="submit" [disabled]="isApiHit">
                                    Continue
                                    <span *ngIf="isApiHit" class="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>